<template>
  <div>
    <ds-heading text="Alocações e Retenções" />

    <ds-async-content-wrapper
      :fetch-action="onFetchDsAsyncContent"
      @fetch-success="onFetchDsAsyncContentSuccess">
      <service-taker-allocation-blankslate
        v-if="shouldShowBlankSlate"
        @period-change="onPeriodChange" />
      <service-taker-allocation-list-page
        v-else
        :service-takers="serviceTakers"
        :period="period"
        :pagination="pagination"
        :fetch-action="onFetch"
        @period-change="onPeriodChange"
        @fetch-success="onFetchSuccess" />
    </ds-async-content-wrapper>
  </div>
</template>

<script>
import ServiceTakerAllocationBlankslate from './ServiceTakerAllocationBlankslate';
import ServiceTakerAllocationListPage from './ServiceTakerAllocationListPage';
import { checkHasAllocationForTenant, getServiceTakersAllocationsList, getPeriodFormatted } from './serviceTakerAllocationService';

export default {
  name: 'ServiceTakerPage',
  components: { ServiceTakerAllocationBlankslate, ServiceTakerAllocationListPage },
  data() {
    return {
      serviceTakers: [],
      pagination: {
        totalItems: 0,
        page: 1,
      },
      period: getPeriodFormatted(),
      shouldShowBlankSlate: true,
    };
  },
  methods: {
    onFetchDsAsyncContent() {
      return checkHasAllocationForTenant();
    },
    onFetchDsAsyncContentSuccess(hasAllocationForTenant) {
      this.shouldShowBlankSlate = !hasAllocationForTenant;
    },
    async onFetch(params = {}) {
      return getServiceTakersAllocationsList(this.period, params);
    },
    async onFetchSuccess({ content, totalElements, number }) {
      this.serviceTakers = content;
      this.pagination = {
        totalItems: totalElements,
        page: number + 1,
      };
    },
    onPeriodChange(period) {
      this.shouldShowBlankSlate = false;
      this.period = period;
      this.pagination = { totalItems: 0, page: 1 };
      this.$nextTick();
    },
  },
};
</script>
